import {Component, Input, ViewEncapsulation} from '@angular/core';
import {setCulture, Browser} from '@syncfusion/ej2-base';
import { HeatMap, Legend, Tooltip, ILoadedEventArgs, ITooltipEventArgs, HeatMapTheme } from '@syncfusion/ej2-angular-heatmap';
import { Internationalization } from '@syncfusion/ej2-base';
HeatMap.Inject(Tooltip, Legend);

setCulture('ko');

@Component({
    selector: 'ejs-heatmap-chart-component',
    templateUrl: 'ejs-heatmap-chart.component.html',
    styleUrls: ['../syncfusion.custom.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EjsHeatmapChartComponent {
    @Input() public chartList: Array<any>;
    @Input() public chartConfig: any;

    public tooltipRender(args: ITooltipEventArgs): void {
        // args.content = [args.yLabel + ' | ' + args.xLabel + ' : ' + args.value + ' ea'];
        args.content = [`${args.yLabel} | ${args.xLabel} : ${args.value} ${this.chartConfig.customTooltipLabel}`];

        // let intl: Internationalization = new Internationalization();
        // let format: Function = intl.getDateFormat({ format: 'EEE MMM dd, yyyy' });
        // let newDate: Date = <Date>args.xValue;
        // let date: Date = new Date(newDate.getTime());
        // let axisLabel: string[] = args.heatmap.axisCollections[1].axisLabels;
        // let index: number = axisLabel.indexOf(args.yLabel);
        // (date).setDate((date).getDate() + index);
        // let value: string = format(date);
        // args.content = [(args.value === 0 ? 'No' : args.value) + ' ' + 'contributions' + '<br>' + value];
    };
    public load(args: ILoadedEventArgs): void {
        let selectedTheme: string = location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.heatmap.theme = <HeatMapTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1));
    };

    constructor() {
        //code
    };
}



// WEBPACK FOOTER //
// ./src/app/components/syncfusion/chart/ejs-heatmap-chart.component.ts